<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="3">Parametri</v-col>
            <v-col cols="8" class="text--secondary">
              <span  v-if="open" key="0">Imposta i parametri per l'importazione</span>
              <span v-else-if="modelloDato" key="1">
                {{ modelloDato && modelloDato.descrizione }} | {{nomeFile}} | {{ riferimento }}
              </span>
            </v-col>
            <v-col cols="12" sm="6" class="d-none d-md-block"></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row justify="space-around" dense>
          <v-col cols="12" sm="6">
            <excel :modelloItem="modelloItem" :resetFile="triggerReset" @onLoaded="onloaded"/>
          </v-col>
          <v-col  cols="12" sm="3">
            <v-switch
              v-model="forzaAggiornamento"
              inset
              dense
              label="Forza aggiornamento valori"
              class="mt-1 ml-2"
            ></v-switch>
          </v-col>
          <v-col>
            <v-btn :loading="loading" @click.stop="onImportWithPassword" :disabled="importaDisabled">Aggiorna dati</v-btn>
          </v-col>          
        </v-row>
        <v-row justify="end" dense>
          <v-col cols="4">Ultima elaborazione: {{ impostazioni.ultimaElaborazione | dateTime}} ({{ distanzaElaborazione }})</v-col>
          <v-col cols="3">Ultima modifica: {{ impostazioni.ultimaModifica | dateTime}}</v-col>
        </v-row>
        <dialog-conferma
          :show="dialogConferma"
          title="Confermi import dati ?"
          :message="forzaAggiornamento ? `ATTENZIONE! E'stata impostata la forzatura dell'aggiornamento !` : ''"
          @dialog-confirm="eseguiImporta"
          @dialog-cancel="dialogConferma=false"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import moment from 'moment'
  import configurazioni from '@/services/configurazioniService.js'
  import tabelle from '@/services/tabelleService.js'
  import DialogConferma from '@/components/dialogConferma'
  import Excel from './excel.vue'
  import excelService from '@/services/excelService'
  import { sanitize } from '@/components/helpers'

  export default {
    components: {
      Excel,
      DialogConferma
    },
    props: {
      loading: Boolean,
      loadingCategorie: Boolean
    },
    data: (vm) => ({
      panel: 0,
      modelliDato: [],
      modelloDato: null,
      modelloItem: null,
      fornitore: null,
      riferimento: '',
      aggiornaCategorie: true,
      menuStart: false,
      modal: false,
      mostraRaw: false,
      totaleDati: 0,
      nomeFile: '',
      dialogConferma: false,
      triggerReset: 0,
      impostazioni: {},
      aggiornamentoEseguito: false,
      forzaAggiornamento: false,
      codiceAvvioProcedura: '0000' // TODO: Mettere su Impostazioni
    }),
    async mounted() {
      const modelli = await configurazioni.getConfigurazione('import_dati', 'modelli')
      this.modelliDato = modelli.custom
      if (this.modelliDato) {
        const modello = this.modelliDato.find(x => x.codice === 'tabacchi')
        if (modello) {
          this.modelloItem = modello
          this.$emit('changeModello', modello)
        }
      }
      await this.leggeDateAggiornamento()
    },
    computed: {
      importaDisabled() {
        return this.totaleDati === 0 || this.mostraRaw || this.aggiornamentoEseguito
      },
      pulisciDisabled() {
        return this.loading || this.loadingCategorie
      },
      distanzaElaborazione() {
        return moment(this.impostazioni.ultimaElaborazione).fromNow()
      }
    },
    watch: {
      mostraRaw(val) {
        this.$emit('cambiaVista', val)
      },
      async loading(val) {
        if (!val) {
          await this.leggeDateAggiornamento()
        }
      }
    },
    methods: {
      async leggeDateAggiornamento() {
        console.log('legge date aggiornamento')
        const impostazioniTabacchi = await tabelle.getImpostazioniAnagraficaTabacchi()
        this.impostazioni = impostazioniTabacchi || {}
      },
/*       onChangeModello(modello) {
        // const modello = this.modelliDato.find(x => x.codice === value)
        this.modelloItem = modello
        this.$emit('changeModello', modello)
      }, */
      onloaded(dati) {
        this.totaleDati = dati ? dati.datiModello.length : 0
        if (!this.riferimento && dati) {
          const nn = dati.nomeFile.split('.')
          nn.pop()
          this.riferimento = nn.join('.')
        }
        this.nomeFile = dati ? dati.nomeFile : ''
        this.$emit('onLoaded', dati)
        this.aggiornamentoEseguito = false
      },
      onPulisci() {
        // this.modelloDato = null
        this.triggerReset++
        // this.fornitore = null
        this.riferimento = ''
        this.$emit('onLoaded', null)
      },
      onImporta() {
        this.dialogConferma = true
      },
      onImportWithPassword() {
        if (prompt('inserire codice per avvio procedura') === this.codiceAvvioProcedura) {
          this.onImporta()
        } else {
          alert('Codice non corretto')
        }
      },
      eseguiImporta() {
        this.$emit('importa', this.forzaAggiornamento)        
        this.dialogConferma = false
        this.aggiornamentoEseguito = true
      },
/*       onAggiornaCategorie() {
        this.$emit('aggiornaCategorie')
      },   */    
      async onDownloadExcelModello() {
        const modello = this.modelloItem
        let colonne = {}
        for (let c of modello.colonne) {
          const nome = c.label || c.campo
          colonne[nome] = ''
        }
        
        await excelService.creaExcelData([colonne], `Modello_${sanitize(modello.descrizione)}.xlsx`)
      }
    }
  }
</script>
